<template>
  <v-layout
    app
    column
    class="align-center"
    >
      <v-row 
        no-gutters
        class="mb-2" 
        v-if="show && $route.meta.sw !== false"
        >
          <mrx-translation :token="message"></mrx-translation>
      </v-row>
      <v-row 
        no-gutters
        class="mb-2" 
        v-if="show && $route.meta.sw !== false"
        >
          <v-btn id="update-app" class="assessment-light panel-opaque" @click="update">
            <v-icon left>{{ icons.mdiCellphoneArrowDown }}</v-icon>
            <mrx-translation token="app.serviceworker.button.update"></mrx-translation>
          </v-btn>
      </v-row>
      <v-row no-gutters class="mb-2" v-if="!readyForPwaInstall && $route.meta.sw !== false" style="width: 100%">
        <v-banner
          :icon="icons.mdiAlert"
          icon-color="red"
          class="warning-banner"
          single-line
          outlined
        >
          <mrx-translation :token="`app.device.list.offline_not_ready.title`"></mrx-translation>
        </v-banner>
      </v-row>
    </v-layout>
</template>

<script>
    import { register } from 'register-service-worker'
    import icons from '@/mixins/icons'
    import mrx from '@/mixins/mrx'
    import { mapActions, mapGetters } from 'vuex'
    let channel

    export default {
        name: 'ServiceWorker',
        mixins: [icons, mrx],
        name: 'ServiceWorker',
        data() {
            return {
                message: null,
                show: false
            }
        },

        watch: {
            // whenever question changes, this function will run
            blockKeen: (val) => {
                try {
                    if (val) {
                        channel.postMessage({ type: 'BLOCK_KEEN' })
                    }
                    else {
                        channel.postMessage({ type: 'UNBLOCK_KEEN' })
                    }
                }
                catch (e) {
                    console.log(e)
                }
            },
            simmulateOffline: (val) => {
                try {
                    if (val) {
                        channel.postMessage({ type: 'OFFLINE_MODE' })
                    }
                    else {
                        channel.postMessage({ type: 'ONLINE_MODE' })
                    }
                }
                catch (e) {
                    console.log(e)
                }
            }
        },

        created() {
            /* 
            let link = document.createElement('link')
            link.rel = 'manifest'
            link.href = 'manifest.json'
            document.head.append(link)
            */
            try {
                channel = new BroadcastChannel('sw-messages')
                channel.addEventListener('message', event => {
                    if (event.data.type === 'RECORD_UPLOADED') {
                        let setLastUploadDate = this.setLastUploadDate
                        let recordsInQueue = this.recordsInQueue
                        setTimeout(function() {
                            recordsInQueue()
                            setLastUploadDate()
                        }, 10000)
                    }
                })
            }
            catch (e) {
                console.log('Service worker functionality not available')
            }
        },
        computed: {
            readyForPwaInstall() {
                if (!this.$store.state.settings.offline) return true
                return this.$store.state.settings.offline && this.$store.state.v4.healthcheck.readyForOffline
            },
            blockKeen() {
                return this.mode('blockKeen')
            },
            simmulateOffline() {
                return this.mode('simmulateOffline')
            },
            ...mapGetters({ 
                settings: 'v4/settings/get', 
                mode: 'v4/mode/get',
                authenticated: 'v4/session/authenticated'
            })
        },
        mounted() {
            this.setReadyForOffline(false)
            if (this.authenticated) {
                this.register()
            }
        },
        methods: {
            async display(message) {
                let recordsInQueue = await this.recordsInQueue()
                this.message = message
                this.show = navigator.serviceWorker !== undefined
            },
            async update() {
                let channel = new BroadcastChannel('noop-sw-messages');
                channel.postMessage('SKIP_WAITING');
                this.setReadyForOffline(true)
                location.reload()
                this.show = false
                this.message = null
            },
            register() {
                /* eslint-disable no-console */
                let display = this.display
                let setReadyForOffline = this.setReadyForOffline
                let settings = this.settings
                try {
                    console.log('Registering ServiceWorker')
                    register('/service-worker.js', {
                        registrationOptions: { scope: './', type: 'module' },
                        async ready(registration) {
                            try {
                                // Fetech user specific assets and add to Cache
                                const response = await fetch('/api/v3/precache-assets'); 
                                const assetsToCache = await response.json();
                                const urlsToCache = [...new Set(assetsToCache.map(asset => asset.url))];

                                const cache = await caches.open('runtime-cache');
                                if (cache) {
                                    await cache.addAll(urlsToCache);
                                    const keys = await cache.keys();
                                    const cacheNotEmpty = keys.length > 0;
                                    console.log(`Cache 'runtime-cache' is ${cacheNotEmpty ? 'populated' : 'empty'}`);
                                    const canBeUsedOffline = cacheNotEmpty && settings('offline');
                                    setReadyForOffline(canBeUsedOffline);
                                }
                                else
                                {
                                    console.log("The 'runtime-cache' was not found.");
                                    setReadyForOffline(false);
                                }
                            } catch (error) {
                                console.error('Error while checking the cache:', error);
                                setReadyForOffline(false);
                            }
                        },
                        registered() {
                            console.log('Service Worker registered')
                        },
                        cached() {
                            setReadyForOffline(settings('offline'))
                            console.log('Content has been cached for offline use.')
                        },
                        updatefound() {
                            setReadyForOffline(false)
                            console.log('New content is downloading.')
                        },
                        updated() {
                            console.log('New content is available; please refresh.')
                            display('app.serviceworker.messages.update')
                        },
                        offline() {
                            console.log('No internet connection found. App is running in offline mode.')
                        },
                        error(error) {
                            setReadyForOffline(false)
                            console.error('Error during service worker registration:', error)
                        }
                    })
                }
                catch (e) {
                    console.log(e)
                }
            },
            ...mapActions({
                setReadyForOffline: 'v4/healthcheck/setReadyForOffline',
                setLastUploadDate: 'v4/collect/setLastUploadDate',
            })
        }
    }
</script>